(function () {
  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    var total = root.querySelectorAll('[data-media]').length;
    if (!total) return;
    var active = 0;
    var touch = null;
    var media = root.querySelectorAll('[data-media]');
    var descriptions = root.querySelectorAll('[data-descriptions] button');
    var tabs = root.querySelectorAll('[data-tab]');
    var position = root.querySelector('[data-position]');
    var evidence = root.querySelector('.cat-tree-material__evidence');
    var caption = root.querySelector('[data-mobile-caption]');
    var cleanups = [];
    function listen(element, event, handler, options) {
      element.addEventListener(event, handler, options);
      cleanups.push(function () { element.removeEventListener(event, handler, options); });
    }
    function update(next) {
      var oldVideo = media[active] && media[active].querySelector('video');
      if (oldVideo) oldVideo.pause();
      active = (next + total) % total;
      media.forEach(function (item, index) { item.hidden = index !== active; });
      descriptions.forEach(function (button, index) { button.setAttribute('aria-pressed', String(index === active)); });
      tabs.forEach(function (button, index) { button.setAttribute('aria-pressed', String(index === active)); });
      var current = media[active].querySelector('video');
      if (current) { current.pause(); current.currentTime = 0; current.load(); }
      position.textContent = (active + 1) + ' / ' + total;
      var source = descriptions[active];
      if (source && evidence) evidence.textContent = media[active].dataset.evidenceValue || '';
      if (caption && source) caption.innerHTML = source.querySelector('div').innerHTML;
    }
    listen(root.querySelector('[data-prev]'), 'click', function () { update(active - 1); });
    listen(root.querySelector('[data-next]'), 'click', function () { update(active + 1); });
    descriptions.forEach(function (button) { listen(button, 'click', function () { update(Number(button.dataset.index)); }); });
    tabs.forEach(function (button) { listen(button, 'click', function () { update(Number(button.dataset.index)); }); });
    var videoWrap = root.querySelector('.cat-tree-material__video-wrap');
    function isMobile() { return window.matchMedia('(max-width: 760px)').matches; }
    function activeVideo() { return media[active] && media[active].querySelector('video'); }
    function isVideoTouch(point) {
      var video = activeVideo();
      if (!video) return false;
      var box = video.getBoundingClientRect();
      return point.clientX >= box.left && point.clientX <= box.right && point.clientY >= box.top && point.clientY <= box.bottom;
    }
    function isVideoControlTouch(point) {
      var video = activeVideo();
      if (!video || !isVideoTouch(point)) return false;
      return point.clientY >= video.getBoundingClientRect().bottom - 72;
    }
    var passive = { passive: true };
    listen(videoWrap, 'touchstart', function (event) {
      touch = null;
      if (!isMobile() || event.touches.length !== 1) return;
      var point = event.touches[0];
      if (!isVideoTouch(point) || isVideoControlTouch(point)) return;
      touch = [point.clientX, point.clientY];
    }, passive);
    listen(videoWrap, 'touchmove', function (event) { if (event.touches.length !== 1) touch = null; }, passive);
    listen(videoWrap, 'touchend', function (event) {
      if (!touch || !isMobile() || event.changedTouches.length !== 1) return;
      var start = touch;
      touch = null;
      var point = event.changedTouches[0];
      if (!isVideoTouch(point) || isVideoControlTouch(point)) return;
      var dx = point.clientX - start[0];
      var dy = point.clientY - start[1];
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) update(active + (dx < 0 ? 1 : -1));
    }, passive);
    listen(videoWrap, 'touchcancel', function () { touch = null; }, passive);
    update(0);
    root._catTreeCleanup = function () { cleanups.forEach(function (cleanup) { cleanup(); }); cleanups = []; media.forEach(function (item) { var video = item.querySelector('video'); if (video) video.pause(); }); root.dataset.initialized = 'false'; };
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-cat-tree-material]').forEach(init); }
  document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { var root = event.target.querySelector && event.target.querySelector('[data-cat-tree-material]'); if (root && root._catTreeCleanup) root._catTreeCleanup(); });
})();
